export const NAME_CELL_WIDTH = 260;
export const ATTAINMENT_CELL_WIDTH = 250;
export const COVERAGE_CELL_WIDTH = 190;
export const COVERAGE_RATIO_CELL_WIDTH = 150;
export const FORECAST_SUBMISSION_CELL_WIDTH = 180;
export const AMOUNT_CELL_WIDTH = 190;